import { AllPlans, SplashPage } from "contexts/Subscription";
import { AddOnDetails, AddOnItemName } from "schemas/dashboard";
import { Plans } from "schemas/payments";

export const getDetails = (
  plan: Plans | AddOnItemName | null,
  plans: AllPlans | null,
  addOns: { [key: string]: AddOnDetails },
  splashPageSource?: SplashPage | null,
) => {
  if (splashPageSource === SplashPage.va_money_back) {
    return {
      display_name: "Virtual Assistant",
      description:
        "300+ emails sent for you every month — plus all of your follow-ups, handled on your behalf.",
      product: "",
      price: 0,
    };
  }
  if (plans && plans[plan as keyof AllPlans]) {
    return plans[plan as keyof AllPlans];
  } else if (addOns && addOns[plan as keyof AllPlans]) {
    return addOns[plan as keyof AllPlans];
  } else {
    return {
      display_name: "",
      description: "",
      product: "",
      price: 0,
    };
  }
};
